// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3106":"d13c1b06","4508":"47253aa2","6909":"cd9a050a","8107":"23eb08ea","8714":"d13c1b06"}[chunkId] + ".chunk.css";
};